
import React, { useEffect, useState } from "react";
import Card from 'components/Card/Card'
import axios from 'axios'
import apiUrl from "../../../variables/api";

import { toast } from 'react-toastify';

import {
    Text,
    Flex, FormControl, FormLabel, Input, FormErrorMessage, Button, Textarea, RadioGroup, Stack, SimpleGrid, AbsoluteCenter, Center, useColorMode, Skeleton
} from "@chakra-ui/react";
import {Field, Form, Formik} from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";

const initialValues = {
    raportType: "",
    raportDescription: "",
};

const validate = (values) => {
    const errors = {};

    if (!values.raportType) {
        errors.raportType = "Musisz wybrać rodzaj raportu"
    }

    if (!values.raportDescription) {
        errors.raportDescription = "Musisz podać tekst raportu"
    }

    return errors;
}

function Page() {
    const { colorMode } = useColorMode();
    const [formData, setFormData] = useState({
        raportType: "",
        raportDescription: "",
    });
    
    
const formikRef = React.useRef();

    const handleSubmit = async  (values, { setSubmitting, resetForm }) => {
        console.log('Dane formularza', values)
        await setFormData(values);
        console.log('Wysyłanie formularza', formData)

        axios.post(apiUrl + '/data/k-t-raport', values, {
            headers: {'x-access-token': localStorage.getItem('token')}
        })
            .then(response => {
                if (response.data.success) {
                    formikRef.current.resetForm()
                    formikRef.current.setSubmitting(false)
                    return toast.success('Pomyślnie wysłano raport kwatermistrzowski')
                } else {
                  formikRef.current.setSubmitting(false)
                  return toast.error('Napotkano błąd podczas wysyłania raportu kwatermistrzowskiego')
                }
            })
            .catch(error => {
                console.error(error);
                formikRef.current.setSubmitting(false)
                toast.error('Napotkano błąd podczas połączenia z API')
            });
    
    };

    return (
        <Flex flexDirection='column' pt={{ base: "120px", md: "75px" }}>
                    <Card minH='125px'>
                        <Formik
                            initialValues={initialValues}
                            validate={validate}
                            // validateOnChange={false}
                            // validateOnBlur={false}
                            onSubmit={handleSubmit}
                            innerRef={formikRef}
                        >
                            {({ isSubmitting, formik }) => (
                                <Form>
                                    <Field name="raportType">
                                        {({ field, form }) => (
                                            <FormControl id="raportType" isRequired isInvalid={form.errors.raportType && form.touched.raportType}>
                                                <FormLabel>Rodzaj zdarzenia</FormLabel>
                                                <RadioGroup
                                                    name="incidentType"
                                                    colorScheme='red'
                                                >
                                                    <Stack direction="row">
                                                        <CustomCheckbox
                                                            key="Przetarg"
                                                            label="Przetarg"
                                                            isChecked={form.values.raportType == ("Przetarg")}
                                                            onChange={() => {
                                                                form.setFieldValue(field.name, "Przetarg");
                                                            }}
                                                        />
                                                        <CustomCheckbox
                                                            key="Sprawozdanie"
                                                            label="Sprawozdanie"
                                                            isChecked={form.values.raportType == ("Sprawozdanie")}
                                                            onChange={() => {
                                                                form.setFieldValue(field.name, "Sprawozdanie");
                                                            }}
                                                        />
                                                        <CustomCheckbox
                                                            key="Wydatek miesięczny"
                                                            label="Wydatek miesięczny"
                                                            isChecked={form.values.raportType == ("Wydatek miesięczny")}
                                                            onChange={() => {
                                                                form.setFieldValue(field.name, "Wydatek miesięczny");
                                                            }}
                                                        />
                                                    </Stack>
                                                </RadioGroup>
                                                <FormErrorMessage>{form.errors.raportType}</FormErrorMessage>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name="raportDescription">
                                        {({ field, form }) => (
                                            <FormControl id="raportDescription" isRequired isInvalid={form.errors.raportDescription && form.touched.raportDescription}>
                                                <FormLabel>Treść</FormLabel>
                                                <Textarea {...field} placeholder="Treść" maxH={"500px"} />
                                                <FormErrorMessage>{form.errors.raportDescription}</FormErrorMessage>
                                            </FormControl>
                                        )}
                                    </Field>

                                    <Button
                                        mt={4}
                                        colorScheme="red"
                                        isLoading={isSubmitting}
                                        type="submit"
                                    >
                                        Wyślij
                                    </Button>
                                    <Button
                                        mt={4}
                                        ml={2}
                                        colorScheme="gray"
                                    >
                                        Anuluj
                                    </Button>

                                </Form>
                            )}
                        </Formik>
                    </Card>
        </Flex>
    );
}

export default Page;